import { Component, OnInit, Input, Injector } from '@angular/core';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { KindBoard } from 'src/utils/enums';
import { InputOrder } from '../inputmodels/inputorder.models';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-quantity-order',
    templateUrl: './inputquantityorder.component.html',
    styleUrls: ['./inputquantityorder.component.css'],
    standalone: false
})

export class InputQuantityOrderComponent extends PageBase implements OnInit {

  @Input() inputQuantityOrder: InputOrder = new InputOrder();
  @Input() isHideLoading: boolean;
  Kind = KindBoard.Insumo;
  inputItem: InputItem = new InputItem();

  constructor(public objInjector: Injector) {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.inputQuantityOrder.id = 0;
    this.inputQuantityOrder.orderDeliveredQuantity = 0;
    this.inputQuantityOrder.orderQuantity = 0;
    this.inputQuantityOrder.percentageDeliveredUnderQuantity = 0;
  }

  onReceiveLiterals(): void { }
}
